import {
  HomeAudience,
  HomeFeature,
  HomeFrame,
  HomeLook,
  HomePalette,
  HomePaletteChoice,
  HomeRecolorShot,
  HomeSeasonPreview,
  HomeStudioTool,
} from './home.types';

export const HOME_FEATURES: HomeFeature[] = [
  {
    titleKey: 'homeFeatureGalleryTitle',
    bodyKey: 'homeFeatureGalleryText',
    src: require('@/assets/home/feature-gallery-lookbook.jpg'),
    pointKeys: ['homeFeatureGallerySearch', 'homeFeatureGalleryLookbook', 'homeFeatureGalleryPdf'],
  },
];

export const HOME_LOOKS: HomeLook[] = [
  {
    src: require('@/assets/home/look-warm-autumn-capsule.jpg'),
    titleKey: 'warmAutumnPaletteShort',
    featured: true,
  },
  {
    src: require('@/assets/home/look-soft-summer-chips.jpg'),
    titleKey: 'homeLookChips',
  },
  {
    src: require('@/assets/home/look-soft-autumn.jpg'),
    titleKey: 'softAutumnPaletteShort',
  },
  {
    src: require('@/assets/home/look-warm-autumn-park.jpg'),
    titleKey: 'homeLookBaseAccent',
  },
  {
    src: require('@/assets/home/look-soft-autumn-mapped.jpg'),
    titleKey: 'homeLookMapped',
  },
];

export const HOME_HERO_COLLAGE: HomeLook[] = [
  {
    src: require('@/assets/home/hero-collage-milan.jpg'),
    titleKey: 'homeLooksTitle',
  },
  {
    src: require('@/assets/home/hero-collage-yellow.jpg'),
    titleKey: 'softAutumnPaletteShort',
  },
  {
    src: require('@/assets/home/hero-collage-floral.jpg'),
    titleKey: 'homeLookChips',
  },
];

export const HOME_RECOLOR: HomeRecolorShot[] = [
  {
    src: require('@/assets/home/ai-recolor-before.jpg'),
    captionKey: 'homeAiRecolorBefore',
  },
  {
    src: require('@/assets/home/ai-recolor-after.jpg'),
    captionKey: 'homeAiRecolorAfter',
  },
  {
    src: require('@/assets/home/ai-recolor-choice-before.jpg'),
    captionKey: 'homeAiRecolorBefore',
    tall: true,
  },
  {
    src: require('@/assets/home/ai-recolor-choice-after.jpg'),
    captionKey: 'homeAiRecolorAfter',
    tall: true,
  },
];

export const HOME_FRAMES: HomeFrame[] = [
  {
    src: require('@/assets/home/frame-bright-winter.jpg'),
    titleKey: 'cold',
  },
  {
    src: require('@/assets/home/frame-warm-spring.jpg'),
    titleKey: 'warm',
  },
  {
    src: require('@/assets/home/frame-dark-winter.jpg'),
    titleKey: 'dark',
  },
  {
    src: require('@/assets/home/frame-light-spring.jpg'),
    titleKey: 'light',
  },
  {
    src: require('@/assets/home/frame-soft-summer.jpg'),
    titleKey: 'mute',
  },
  {
    src: require('@/assets/home/frame-bright-spring.jpg'),
    titleKey: 'bright',
  },
];

export const HOME_PALETTES: HomePalette[] = [
  {
    src: require('@/assets/home/palette-soft-summer.jpg'),
    titleKey: 'softSummerPaletteShort',
  },
  {
    src: require('@/assets/home/palette-soft-autumn.jpg'),
    titleKey: 'softAutumnPaletteShort',
  },
  {
    src: require('@/assets/home/palette-bright-winter.jpg'),
    titleKey: 'brightWinterPaletteShort',
  },
  {
    src: require('@/assets/home/palette-bright-spring.jpg'),
    titleKey: 'brightSpringPaletteShort',
  },
  {
    src: require('@/assets/home/palette-warm-spring.jpg'),
    titleKey: 'warmSpringPaletteShort',
  },
  {
    src: require('@/assets/home/palette-light-spring.jpg'),
    titleKey: 'lightSpringPaletteShort',
  },
  {
    src: require('@/assets/home/palette-light-summer.jpg'),
    titleKey: 'lightSummerPaletteShort',
  },
  {
    src: require('@/assets/home/palette-cold-winter.jpg'),
    titleKey: 'coldWinterPaletteShort',
  },
  {
    src: require('@/assets/home/palette-cold-summer.jpg'),
    titleKey: 'coldSummerPaletteShort',
  },
  {
    src: require('@/assets/home/palette-warm-autumn.jpg'),
    titleKey: 'warmAutumnPaletteShort',
  },
  {
    src: require('@/assets/home/palette-dark-autumn.jpg'),
    titleKey: 'darkAutumnPaletteShort',
  },
  {
    src: require('@/assets/home/palette-dark-winter.jpg'),
    titleKey: 'darkWinterPaletteShort',
  },
];

export const HOME_PALETTE_CHOICE: HomePaletteChoice = {
  src: require('@/assets/home/palette-choice.jpg'),
  captionKey: 'homePaletteChoice',
};

export const HOME_STOCK_LOOKS: HomeLook[] = [
  {
    src: require('@/assets/home/stock-stylist.jpg'),
    titleKey: 'homeStockLookStylist',
  },
  {
    src: require('@/assets/home/stock-studio.jpg'),
    titleKey: 'homeStockLookStudio',
  },
  {
    src: require('@/assets/home/stock-colorist.jpg'),
    titleKey: 'homeStockLookColorist',
  },
];

export const HOME_AUDIENCE: HomeAudience[] = [
  { titleKey: 'individualReadyText' },
  { titleKey: 'fashionLoversText' },
  { titleKey: 'designersCravingText' },
];

export const HOME_SEASON_PREVIEWS: HomeSeasonPreview[] = [
  {
    titleKey: 'warmAutumnPaletteShort',
    traitKey: 'homeSeasonWarmAutumnTrait',
    swatches: ['#E18552', '#F6BA72', '#ADA14B', '#715638'],
  },
  {
    titleKey: 'brightWinterPaletteShort',
    traitKey: 'homeSeasonBrightWinterTrait',
    swatches: ['#D3363F', '#604E9A', '#FFFFFF', '#141414'],
  },
  {
    titleKey: 'lightSpringPaletteShort',
    traitKey: 'homeSeasonLightSpringTrait',
    swatches: ['#F99E71', '#F8D47C', '#BADA97', '#4EC1BC'],
  },
  {
    titleKey: 'softSummerPaletteShort',
    traitKey: 'homeSeasonSoftSummerTrait',
    swatches: ['#B28184', '#527A93', '#A4AFC5', '#807D92'],
  },
];

export const HOME_STUDIO_TOOLS: HomeStudioTool[] = [
  {
    titleKey: 'homeStudioAnalysisTitle',
    bodyKey: 'homeStudioAnalysisText',
    accent: '#fa496e',
    icon: 'analysis',
  },
  {
    titleKey: 'homeStudioWardrobeTitle',
    bodyKey: 'homeStudioWardrobeText',
    accent: '#a67eff',
    icon: 'wardrobe',
  },
  {
    titleKey: 'homeStudioRecolorTitle',
    bodyKey: 'homeStudioRecolorText',
    accent: '#52dbff',
    icon: 'recolor',
  },
];
